import {
  Add_Area,
  Delete_Area,
  Get_All_Area,
  Get_Error,
  Get_One_Area,
  Update_One_Area,
} from '../Types';

const intial = {
  Area: [],
  UpdateArea: [],
  loading: true,
};

const Area_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Area:
      return {
        ...state,
        Area: action.payload,
        loading: false,
      };
    case Get_All_Area:
      return {
        ...state,
        Area: action.payload,
        loading: false,
      };
    case Delete_Area:
      return {
        ...state,
        Area: action.payload,
        loading: false,
      };
    case Get_One_Area:
      return {
        ...state,
        Area: action.payload,
        loading: false,
      };
    case Update_One_Area:
      return {
        ...state,
        UpdateArea: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Area: action.payload,
      };
    default:
      return state;
  }
};

export default Area_Reducer;
